import Image from 'next/image'
import { useEffect, useRef } from 'react'

import { Card } from '@wartek-id/card'
import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'
import { Badge } from '@wartek-id/badge'

import type { PeriodikType } from 'types/kinerja'

type CardPenilaianPeriodikProps = {
  periodicType: PeriodikType
  href?: string
  onCtaClick?: () => void
}

const HIGHLIGHT_QUERY_PARAM_KEY = 'highlight-periodik'

export default function CardPenilaianPeriodik({
  href,
  onCtaClick,
  periodicType,
}: CardPenilaianPeriodikProps) {
  // -----------------------------------------------------
  // Handle auto highlight by scrolling the card into view
  // -----------------------------------------------------
  const cardRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    // Read the flag on query param
    const urlParams = new URLSearchParams(window.location.search)
    const shouldHighlight = urlParams.get(HIGHLIGHT_QUERY_PARAM_KEY)

    if (shouldHighlight === 'true') {
      // Scroll into the view
      cardRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })

      // Delete the query param
      urlParams.delete(HIGHLIGHT_QUERY_PARAM_KEY)
      const newUrl = `${window.location.pathname}${
        urlParams.toString() ? `?${urlParams.toString()}` : ''
      }`
      window.history.replaceState(null, '', newUrl)
    }
  }, [])

  if (periodicType === 'NOT_FOUND') return null

  return (
    <Card ref={cardRef}>
      <div className="p-6 flex gap-8 justify-between">
        <div className="flex gap-6 items-start">
          <div className="shrink-0">
            <Image
              src="/illustrations/img-chalk-board-document-progress.png"
              width={64}
              height={64}
              alt=""
            />
          </div>

          <div className="flex flex-col gap-2">
            <div className="flex gap-2 items-center">
              <Text as="h3" variant="heading-lg">
                Penilaian Periodik
              </Text>
              <Badge color="warning" className="!bg-orange-40 !text-white">
                {periodicType === 'BULANAN' ? 'Bulanan' : 'Triwulan'}
              </Badge>
            </div>
            <Text color="subdued">
              Dilakukan sebagai alat bantu (tidak wajib) untuk memenuhi{' '}
              <strong>
                kebutuhan administrasi kepegawaian sesuai kebijakan KemenPANRB,
                BKN, dan Pemerintah Daerah.
              </strong>
            </Text>
          </div>
        </div>

        <div className="shrink-0">
          <Button
            as="a"
            size="lg"
            type={undefined}
            href={href}
            onClick={onCtaClick}
          >
            Ke Penilaian Periodik
          </Button>
        </div>
      </div>
    </Card>
  )
}
